import styles from '../styles/navbar.module.scss';

import { useState, useRef, useEffect } from 'react';
import { Button, Image } from '@aws-amplify/ui-react';
import { ICampaign, IRetailer } from '../models/Campaign';
import SuperTokensReact from 'supertokens-auth-react';

import SessionReact from 'supertokens-auth-react/recipe/session';
import Link from 'next/link';
import RetailersModal from './retailersModal';
import router from 'next/router';

const Navbar = ({ campaignData, filteredRetailers, userEmail, isUserAuthenticated, logoWide = false }: NavbarProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const menuRef = useRef<HTMLButtonElement>(null);
  const logoutButtonRef = useRef<HTMLButtonElement>(null);
  const userProfileButtonRef = useRef<HTMLButtonElement>(null);
  const featuredButtonRef = useRef<HTMLButtonElement>(null);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  async function onLogOut() {
    await SessionReact.signOut();
    SuperTokensReact.redirectToAuth();
    console.log('User Logged Out');
  }

  const profileHandler = () => {
    router.push(`/profile`);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        !event.target.closest('a') &&
        event.target !== logoutButtonRef.current &&
        event.target !== userProfileButtonRef.current &&
        event.target !== featuredButtonRef.current
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef, logoutButtonRef]);

  return (
    <>
      <div className={styles.nav_screen} style={{backgroundColor: campaignData?.backgroundcolor}}>
        <div className={styles.navbar}>
          <div className={styles.navbar_header}>
            <Image
              alt="Logo Image"
              className={logoWide ? styles.nav_logo_ImageWide : styles.nav_logo_Image}
              src={
                logoWide ? campaignData?.LogoImageWide : (campaignData?.LogoImage ||
                'https://uploads-ssl.webflow.com/5be3a787a9b14f88f88bfce4/606c9025d3502d5cd019db51_sampoll-logo-21.svg')
              }
              onClick={() => router.push(campaignData?.BrandUrl || "/")}
            />
            <button className={styles.nav_menu_btn} style={{backgroundColor: `${campaignData?.backgroundcolor || '#FFFFFF'}` }} onClick={toggleMenu} ref={menuRef}>
              <span
                className={styles.line}
                style={{ backgroundColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
              ></span>
              <span
                className={styles.line}
                style={{ backgroundColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
              ></span>
              <span
                className={styles.line}
                style={{ backgroundColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
              ></span>
            </button>
          </div>
          <div className={styles.menu_container}>
            {isOpen && (
              <div
                className={`${styles.nav_menu_btn_open}`}
                style={{
                  borderColor: `${campaignData?.ButtonColor || '#597ef7'}`,
                }}
              >
                {userEmail && isUserAuthenticated && (
                  <Button
                    className={styles.nav_link}
                    style={{ borderColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
                    onClick={profileHandler}
                    ref={userProfileButtonRef}
                  >
                    👤 Profile
                  </Button>
                )}
                {campaignData?.BrandRetailLocationsUrl && (
                  <Link
                    href={`${campaignData?.BrandRetailLocationsUrl}`}
                    id="menu-storelocator-button"
                    target="_blank"
                    className={styles.nav_link}
                    style={{ borderColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
                  >
                    📍 <span>{campaignData?.BrandName} </span> Store Locator
                  </Link>
                )}
                {filteredRetailers && !(campaignData && 'IsSweepstakes' in campaignData && campaignData.IsSweepstakes) && (
                  <a
                    className={styles.nav_link}
                    style={{ borderColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
                    onClick={toggleModal}
                  >
                    🛒 Participating Retailers
                  </a>
                )}
                {/* <Button
                  className={styles.nav_link}
                  style={{ borderColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
                  onClick={() => router.push('/featuredoffers')}
                  ref={featuredButtonRef}
                >
                  ✨ Featured Offers
                </Button> */}
                <Link
                  href={{
                    pathname: '/support/sam-help',
                    query: { cid: campaignData?.CampaignId, email: userEmail },
                  }}
                  rel="noopener noreferrer"
                  target="_blank"
                  className={styles.nav_link}
                  style={{ borderColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
                >
                  😬 Help Me
                </Link>
                {!userEmail && !isUserAuthenticated && (
                  <Link
                    href="/support/sam-samples"
                    rel="noopener noreferrer"
                    target="_blank"
                    className={styles.nav_link}
                    style={{ borderColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
                  >
                    ✅ Get More samples!
                  </Link>
                )}
                {userEmail && isUserAuthenticated && (
                  <Button
                    className={styles.nav_link}
                    style={{ borderColor: `${campaignData?.ButtonColor || '#597ef7'}` }}
                    onClick={onLogOut}
                    ref={logoutButtonRef}
                  >
                    🔌 Log Out
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
        <RetailersModal showModal={showModal} toggleModal={toggleModal} filteredRetailers={filteredRetailers} campaignData={campaignData} />
        {campaignData?.ShowDivider && <hr className={styles.border}></hr>}
      </div>
    </>
  );
};

interface NavbarProps {
  campaignData?: ICampaign;
  filteredRetailers?: IRetailer[];
  userEmail?: string;
  isUserAuthenticated?: boolean;
  logoWide?: boolean;
}

export default Navbar;
